export const SIDEBAR_COLLAPSED_WIDTH = 48;
